import { BaseModel } from './base';

export enum VoucherDiscountType {
  fixed = 0,
  percentage = 1,
}

export const VoucherDiscountTypeLabels: Record<VoucherDiscountType, string> = {
  [VoucherDiscountType.fixed]: 'general.fixed',
  [VoucherDiscountType.percentage]: 'general.percentage',
};

export enum VoucherTaxType {
  post = 0,
  pre = 1,
}

export const VoucherTaxTypeLabels: Record<VoucherTaxType, string> = {
  [VoucherTaxType.post]: 'general.post',
  [VoucherTaxType.pre]: 'general.pre',
};

export enum VoucherCustomerType {
  all = 0,
  new = 1,
  existing = 2,
  segments = 3,
}

export const VoucherCustomerTypeLabels: Record<VoucherCustomerType, string> = {
  [VoucherCustomerType.all]: 'general.all',
  [VoucherCustomerType.new]: 'general.new',
  [VoucherCustomerType.existing]: 'api.models.voucher.existing',
  [VoucherCustomerType.segments]: 'general.segments',
};

export enum VoucherMultipleMode {
  any = 0,
  singleFirst = 1,
  singleLowest = 2,
  singleHighest = 3,
}

export const VoucherMultipleModeLabels: Record<VoucherMultipleMode, string> = {
  [VoucherMultipleMode.any]: 'api.models.voucher.any',
  [VoucherMultipleMode.singleFirst]: 'api.models.voucher.singleFirst',
  [VoucherMultipleMode.singleLowest]: 'api.models.voucher.singleLowest',
  [VoucherMultipleMode.singleHighest]: 'api.models.voucher.singleHighest',
};

export class Voucher extends BaseModel {
  idVoucher!: number;
  code!: string;
  name!: string;
  discountType!: VoucherDiscountType;
  discountTaxType!: VoucherTaxType;
  customerType!: VoucherCustomerType;
  multipleMode!: VoucherMultipleMode;
  discountAmount!: number;
  validStartTime!: number | null;
  validEndTime!: number | null;
  validStartDate!: number | null;
  validEndDate!: number | null;
  startDate!: number | null;
  endDate!: number | null;
  validMonday!: boolean;
  validTuesday!: boolean;
  validWednesday!: boolean;
  validThursday!: boolean;
  validFriday!: boolean;
  validSaturday!: boolean;
  validSunday!: boolean;

  override objectID(): string | null {
    return this.idVoucher?.toString() ?? null;
  }

  get isDiscountTypeFixed(): boolean {
    return this.discountType === VoucherDiscountType.fixed;
  }

  get isDiscountTypePercentage(): boolean {
    return this.discountType === VoucherDiscountType.percentage;
  }

  get isCustomerTypeAll(): boolean {
    return this.customerType === VoucherCustomerType.all;
  }

  get isCustomerTypeNew(): boolean {
    return this.customerType === VoucherCustomerType.new;
  }

  get isCustomerTypeExisting(): boolean {
    return this.customerType === VoucherCustomerType.existing;
  }

  get isCustomerTypeSegments(): boolean {
    return this.customerType === VoucherCustomerType.segments;
  }
}
